export default __webpack_public_path__ + "static/media/wetez_inflation.0f156379.svg";